import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { Button, Dialog, TextField } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import SearchOfferItemComponent from './SearchOfferItemComponent';
import { CardActionsContainer } from 'components/common/CardStyles';
import FakeTextWrapper from 'components/common/FakeTextWrapper';

const SearchOfferComponent = ({
  offerDetails,
  loading,
  searching,
  onSetDocumentNumber,
  onCloseModal,
  onToggleSelectItem,
  onRetrieveOffers,
  documentNumber,
  selected,
  onCopyItem
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      id='search-offer-dialog'
      open
      fullWidth
      maxWidth={'md'}
      onClose={onCloseModal}
      title={t('Offer.Edit.GeneralData.FinancingOffers')}
      content={
        <Grid container justifyContent={'center'}>
          <Grid item xs={12} sm={6}>
            <TextField
              placeholder={t('Offer.Edit.GeneralData.SearchOffer')}
              fullWidth
              name='financingOffers_DocumentNumber'
              value={documentNumber}
              onChange={onSetDocumentNumber}
            />
          </Grid>
          <Table id={'offers_list'}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>
                  <strong>{t('Offer.Edit.OfferDetail.ChassisNumber')}</strong>
                </TableCell>
                <TableCell>
                  <strong>{t('Offer.Edit.OfferDetail.Brand')}</strong>
                </TableCell>
                <TableCell>
                  <strong>{t('Offer.Edit.OfferDetail.Model')}</strong>
                </TableCell>
                <TableCell>
                  <strong>{t('Offer.Edit.OfferDetail.PurchasePrice')}</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!loading &&
                offerDetails.map((offer, index) => (
                  <SearchOfferItemComponent key={index} item={offer} onToggleSelectItem={onToggleSelectItem} />
                ))}
            </TableBody>
          </Table>
          {loading && <FakeTextWrapper lines={5} />}
        </Grid>
      }
      actions={
        <CardActionsContainer mr={1} mb={1}>
          <Button onClick={() => onRetrieveOffers(documentNumber)} disabled={searching}>
            {searching ? t('General.Searching') : t('General.Search')}
          </Button>
          <Button disabled={!selected} onClick={onCopyItem}>
            {t('Offer.Edit.GeneralData.CopyDetail')}
          </Button>
          <Button onClick={onCloseModal}>{t('General.Close')}</Button>
        </CardActionsContainer>
      }
    />
  );
};

SearchOfferComponent.propTypes = {
  offerDetails: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  searching: PropTypes.bool.isRequired,
  documentNumber: PropTypes.string.isRequired,
  onSetDocumentNumber: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  onToggleSelectItem: PropTypes.func.isRequired,
  onRetrieveOffers: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
  onCopyItem: PropTypes.func.isRequired
};

export default SearchOfferComponent;
